<template>
  <v-card>
    <v-card-title>
      <span class="headline">Регистрация нового пользователя</span>
    </v-card-title>

    <v-card-text>
      <v-alert
        v-model="showAlert"
        color="error"
        icon="warning"
        outline
        dismissible
      >
        {{ errorMessage }}
      </v-alert>
      <a @click="showEnterCode" v-if="needConfirm">Подтвердить</a>
      
      <v-form ref="form" v-model="valid" class="mt-4" onSubmit="return false;">
        <template v-if="data_sent">
          <v-text-field
            type="number"
            min="100001"
            max="999998"
            label="Введите код подтверждения"
            v-model="verification_code"
          />

          <span v-if="count > 0">Выслать код повторно можно будет через {{ count }} сек.</span>
          <a v-else @click.prevent="sendCodeAgain">Выслать код повторно</a>
        </template>

        <template v-else>
          <v-text-field
            label="Email или телефон"
            v-model="email_phone"
            :rules="emailOrPhoneRules"
            placeholder="Например, ivan@mail.ru или +7(999)123-45-67"
            required
          />

          <v-text-field
            label="Пароль"
            type="password" 
            v-model="password"
            :rules="passwordRules"
            required
            :type="viewMode ? 'text' : 'password'"
            :append-icon="viewMode ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="viewMode=!viewMode"
          />

          <v-text-field
            label="Повторите пароль"
            type="password" 
            v-model="password_confirm"
            :rules="passwordConfirmRules"
            required
            :type="viewModeC ? 'text' : 'password'"
            :append-icon="viewModeC ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="viewModeC=!viewModeC"
          />
        </template>
        
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red" flat @click.native="closeDialog">Отменить</v-btn>
      <v-btn flat
        color="light-blue darken-2"
        @click.native="register" 
        :disabled="!valid || (data_sent && !verification_code)"
      >
        Зарегистрироваться
      </v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>
import apiAuth from "../api"
import { isEmpty } from 'lodash'

export default {
  name: 'register',

  props: {},
  
  computed:{
    showAlert: {
      get: function() {
        return !isEmpty(this.errorMessage)
      },
      set: function(newValue) {
        if (!newValue) this.errorMessage = ''
      }
    }
  },
  
  data () {
    return {
      lastname: '',
      firstname: '',
      email_phone: '',
      password: '',
      password_confirm: '',
      data_sent: false,
      needConfirm: false,
      viewMode: false,
      viewModeC: false,
      
      verification_code: '',
      initCountValue: 59,
      count: this.initCountValue,
      timer: null,
      errorMessage: '',

      valid: true,
      emailOrPhoneRules: [
        v => !!v || 'Необходимо ввести электронный адрес или телефон',
        // phone only:
        // v => /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test(v) || 'E-mail or Phone number must be valid'
        // email only:
        // v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail or Phone number must be valid'
        // email || phone
        v => /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail or Phone number must be valid'
      ],
      passwordRules: [
        v => !!v || 'Необходимо ввести пароль',
        v => (v && v.length >= 10) || 'Длина пароля должна быть от 10 символов'
      ],
      passwordConfirmRules: [
        v => !!v || 'Необходимо ввести подтверждение пароля',
        v => (v === this.password) || 'Подтверждение пароля не совпадает с паролем'
      ]
    }
  },

  methods: {
    closeDialog() {
      this.$emit('close-dialog')
    },

    makeInterval() {
      this.count = this.initCountValue
      
      this.timer = setInterval(() => {
        if (this.count > 0) {
          this.count--
        } else {
          clearInterval(this.timer)
        }
      }, 1000)
    },

    sendCodeAgain() {
      apiAuth.resendCode({
        email_phone: this.email_phone,
        context: 'reg'
      }).then(response => {
        this.makeInterval()
      }).catch(error => {
        console.warn(error)
      })
    },
  
    showEnterCode(){
      this.data_sent = true
      this.sendCodeAgain()
      this.needConfirm = false
      this.showAlert = false
    },

    register() {
      this.errorMessage = ''

      if (!this.data_sent) {
        if (this.$refs.form.validate()) {
          if( this.email_phone.indexOf("@") < 0 ){
            this.email_phone = this.email_phone.replace(/[^0-9]/gim,'')
          }
          apiAuth.signUp({
            'email_phone': this.email_phone,
            'password': this.password,
            'password_confirm': this.password_confirm,
          }).then(response => {
            this.makeInterval()
            this.data_sent = true
          }).catch(error => {
            this.errorMessage = error.response && error.response.data && error.response.data.error 
              ? error.response.data.error
              : "Server connection error"
  
            if (error.response && error.response.data && error.response.data.code === 'account.user_not_confirm') {
              this.needConfirm = true
            }
          })
        }
      } else {
        apiAuth.confirm({
          'email_phone': this.email_phone,
          'code': parseInt(this.verification_code),
        }).then(response => {
          this.$store.commit('app/account/setAuthTokens', response)
          if (localStorage) {
            localStorage.setItem("dms_auth_tokens", JSON.stringify(response))
          }
          document.location.assign(process.env.APP_ACCOUNT_URL || '/account')
          this.closeDialog()
        }).catch(error => {
          this.errorMessage = error.response && error.response.data && error.response.data.error 
            ? error.response.data.error
            : "Server connection error"
        })
      }
    },
  },
}
</script>

<style scoped>
  .error--text{
    color: #f44336 !important;
    caret-color: #f44336 !important;
  }
</style>



// WEBPACK FOOTER //
// src/apps/auth/components/RegisterForm.vue